export default __webpack_public_path__ + "static/media/share.f9f0499e.svg";